/* unplugin-vue-components disabled */import script from "./Hot.vue?vue&type=script&setup=true&lang=js"
export * from "./Hot.vue?vue&type=script&setup=true&lang=js"

import "./Hot.vue?vue&type=style&index=0&id=74438fde&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74438fde"]])

export default __exports__